import Vue from 'vue'
// import _ from 'lodash'
/* eslint-disable */
export default {
  namespaced: true,
  state: {
    loading: true,
    error: false,
    ombrelloni: [],
    openSeat: {
      open: false,
      seat: ''
    }
  },
  actions: {
    getOmbrelloni ({commit, rootState}) {
      // console.log('getOmbrelloni: ')
      commit('SET_LOADING', true)
      return new Promise((resolve, reject) => {
        Vue.http
          .post(process.env.VUE_APP_API + '/hotel/ombrelloni', {hotels: rootState.hotels, hotelid: rootState.hotels.activehotel?._id || '1'},
          {
            headers: {
              'Authorization': 'Bearer ' + rootState.jwt.jwt
            }
          },
          ).then(response => {
            // console.log(response.data)
            commit('LOAD_OMBRELLONI', response.data.ombrells)
            commit('SET_LOADING', false)
            resolve('ok')
          }, error => {
            reject(error)
            commit('SET_LOADING', false)
            this._vm.$notify({
              title: 'Errore connessione',
              message: 'prego riprovare',
              type: 'error'
            })
          })
      })
      // Vue.http
      //   .post(process.env.VUE_APP_API + '/hotel/ombrelloni', {hotels: rootState.hotels, hotelid: rootState.hotels.activehotel._id},
      //   {
      //     headers: {
      //       'Authorization': 'Bearer ' + rootState.jwt.jwt
      //     }
      //   },
      //   ).then(response => {
      //     // console.log(response)
      //     commit('LOAD_OMBRELLONI', response.data.ombrells)
      //     // commit('SET_LOADING', false)
      //   }, (error) => {
      //     commit('SET_LOADING', false)
      //     this._vm.$notify({
      //       title: 'Errore connessione',
      //       message: 'prego riprovare',
      //       type: 'error'
      //     })
      //   })
    },
    updateOmbrelloni ({commit, rootState}, data) {
      // console.log('updateOmbrelloni: ', data)
      commit('SET_LOADING', true)
      return new Promise((resolve, reject) => {
        Vue.http
          .post(process.env.VUE_APP_API + '/ombrelloni/updateseasons', data,
          {
            headers: {
              'Authorization': 'Bearer ' + rootState.jwt.jwt
            }
          },
          ).then(response => {
            // console.log(response.data)
            resolve('ok')
            commit('SET_LOADING', false)
            // dispatch('getHotels')
          }, error => {
            reject(error)
            commit('SET_LOADING', false)
            this._vm.$notify({
              title: 'Errore connessione',
              message: 'prego riprovare',
              type: 'error'
            })
          })
      })
    },
    updateOmbrids ({commit, dispatch, rootState}, data) {
      // console.log('updateOmbrids: ', data)
      commit('SET_LOADING', true)
      return new Promise((resolve, reject) => {
        Vue.http
          .post(process.env.VUE_APP_API + '/ombrelloni/updateombrids', data,
          {
            headers: {
              'Authorization': 'Bearer ' + rootState.jwt.jwt
            }
          },
          ).then(response => {
            // console.log(response.data)
            commit('SET_LOADING', false)
            dispatch('getOmbrelloni').then(() => {
              resolve('ok')
            })
          }, error => {
            reject(error)
            commit('SET_LOADING', false)
            this._vm.$notify({
              title: 'Errore connessione',
              message: 'prego riprovare',
              type: 'error'
            })
          })
      })
    }
    // updateOmbrellone ({rootState}, data) {
    //   console.log('updateOmbrellone: ', data)
    //   Vue.http
    //     .post(process.env.VUE_APP_API + '/ombrellone', { guest: data.guest, hotel: rootState.hotels.activehotel, seat: data.seat },
    //     {
    //       headers: {
    //         'Authorization': 'Bearer ' + rootState.jwt.jwt
    //       }
    //     },
    //     ).then(response => {
    //       console.log(response.data)
    //       // dispatch('getHotels')
    //     })
    // }
  },
  mutations: {
    SET_LOADING (state, data) {
      state.loading = data
    },
    LOAD_OMBRELLONI (state, response) {
      state.ombrelloni = response
      state.loading = false
    },
    SET_OPENSEAT (state, data) {
      console.log('store: ', data)
      state.openSeat.open = !state.openSeat.open
      state.openSeat.seat = data
    },
    SET_FIRST_SEAT (state, data) {
      console.log(data)
      var seat = {
        ombrid: data.ombrid,
        sortorder: 1,
        new: true
      }
      state.ombrelloni.push(seat)
    }
  },
  getters: {}
}
